"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_AGENTS = void 0;
// User agent strings for product api
const USER_AGENTS = exports.USER_AGENTS = {
  SWP: 'GoDaddy.FOS.SWP',
  QE: 'GoDaddy.FOS.QE'
};